import m from "./atoms-v2759.js";
function i(e, r, f) {
  if (r[e])
    return new m(e, r[e], f);
}
export {
  i as default
};
